// @flow

// These two are NOT actual states from `JobStateEnum` but I think they probably
// really should be at some point to make logic simpler and match Build enum states,
// especially now that steps are a thing. Currently these need to be derived from multiple
// other properties of a Job.
export const VIRTUAL_BUILD_STATES = {
  STARTED: "STARTED"
};

export const BUILD_STATES = {
  SKIPPED: "SKIPPED",
  SCHEDULED: "SCHEDULED",
  RUNNING: "RUNNING",
  PASSED: "PASSED",
  SOFT_FAILED: "SOFT_FAILED",
  FAILED: "FAILED",
  CANCELING: "CANCELING",
  CANCELED: "CANCELED",
  BLOCKED: "BLOCKED",
  NOT_RUN: "NOT_RUN"
};

export default BUILD_STATES;

